// Права ролей пульта (задача D4). Решает сервер (RBAC, `config.access` маршрутов); пульт по правам только прячет
// кнопки и разделы, которые роли всё равно не откроются.
import type { Role } from '@contract/index.js';

/**
 * - `view` — смотреть экраны;
 * - `review` — оценивать ответы, «Исправить → в примеры», «На проверку»;
 * - `launch` — менять ступень, каналы, долю, «Остановить везде»;
 * - `run_checks` — «Проверить всё» в «Готовности», повтор хода;
 * - `run_eval` — запускать прогоны;
 * - `see_trace` — ID трассы и ссылка Langfuse;
 * - `see_phone` — телефон клиента целиком (у остальных его маскирует сервер);
 * - `label_judge` — размечать вердикты судьи «Судья прав / ошибся» в разборе (план M, M2: admin и editor).
 */
export const PERMISSIONS = ['view', 'review', 'launch', 'run_checks', 'run_eval', 'see_trace', 'see_phone', 'label_judge'] as const;
export type Permission = (typeof PERMISSIONS)[number];

/**
 * Админ — всё; «Просмотр» — только смотреть; «Редактор базы» (в v1 видит пульт как «Просмотр») — смотреть и размечать
 * вердикты судьи.
 */
const ROLE_PERMISSIONS: Readonly<Record<Role, ReadonlySet<Permission>>> = {
  admin: new Set(PERMISSIONS),
  viewer: new Set<Permission>(['view']),
  editor: new Set<Permission>(['view', 'label_judge']),
};

export function can(role: Role, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role].has(permission);
}
